import React from 'react'
import PageLayout from '../PageLayout'
import MaterialsTable from './MaterialsTable'

// const useStyles = makeStyles(theme => ({
//     content: {
//        //
//     },
// }))


export default function AppMaterialsPage() {
    // const classes = useStyles()

    // console.log('AppMaterialsPage render')

    return (
        <PageLayout>
            <MaterialsTable />
        </PageLayout>
    )
}

